import "./Investment.css";
import ScrollPage, {SectionItem} from "../../Components/ScrollPage/ScrollPage";
import Section from "../../Components/Section/Section";
import BuisnessModel from "../../Content/Business Model/BusinessModelNew";
import Competition from "../../Content/Competition/CompetitionNew";
import DeRisking from "../../Content/DeRisking/DeRiskingNew";
import ElfPower from "../../Content/ElfPower/ElfPowerNew";
import GoToMarket from "../../Content/GoToMarketNew/GoTomarketNew";
import HighROI from "../../Content/HighROI/HighROINew";
import RevenueScenario from "../../Content/RevenueScenario/RevenueScenarioNew";

interface ScrollTo {
  index: number;
}

export const Sections: SectionItem[] = [
  { label: "Elf-Tech",        id: "elf-tech" },
  { label: "Business Model",   id: "business-model" },
  { label: "Revenue",          id: "revenue" },
  { label: "Go To Market",   id: "go-to-market" },
  { label: "ROIs",  id: "rois" },
  { label: "De-Risking",    id: "de-risking" },
  { label: "Competition",    id: "competition" }
];


const Investment: React.FC<ScrollTo> = ({ index }) => (
  <ScrollPage index={index} sections={Sections}>
    <Section section={Sections[0].id}>
        <ElfPower />
    </Section>
    <Section section={Sections[1].id}>
      <BuisnessModel />
    </Section>
    <Section section={Sections[2].id}>
      <RevenueScenario />
    </Section>
    <Section section={Sections[3].id}>
      <GoToMarket />
    </Section>
    <Section section={Sections[4].id}>
      <HighROI />
    </Section>
    <Section section={Sections[5].id}>
      <DeRisking/>
    </Section>
    <Section section={Sections[6].id}>
      <Competition />
    </Section>
  </ScrollPage>
);

export default Investment;